import styles from './styles.module.scss';
import { TitleInput } from 'components/ClientsDrawer/InviteTeamMember/TitleInput';
import { useState } from 'react';
import { ConfirmationDialog } from 'components';
import { useDispatch } from 'react-redux';
import { requestGetSymphonyListEffect, updateMemberProfileEffect } from 'store/effects';
import { showSuccessMessage } from 'helpers';

type EditTitleModalProps = {
  open: boolean;
  setOpen: Function;
  contact;
};

const EditTitleModal = (props: EditTitleModalProps) => {
  const { open, setOpen, contact } = props;
  const [titleValue, setTitleValue] = useState<any>(
    contact.Title?.Title && contact.Title?.Id
      ? { name: contact.Title.Title, titleId: contact.Title.Id, value: contact.Title.Id }
      : {},
  );
  const dispatch = useDispatch();
  const [saving, setSaving] = useState<boolean>(false);

  const onSubmitConfirmModal = () => {
    setSaving(true);
    dispatch(
      updateMemberProfileEffect(
        { titleFreeText: titleValue?.titleFreeText || titleValue?.title?.name },
        { agentId: contact.Id, silent: true },
        (err) => {
          setSaving(false);
          if (!err) {
            dispatch(requestGetSymphonyListEffect({}, { silent: true }));
            setOpen(false);
            showSuccessMessage(`Agent title updated.`);
          }
        },
      ),
    );
  };

  return (
    <ConfirmationDialog
      onReject={() => setOpen(false)}
      onConfirm={onSubmitConfirmModal}
      isOpen={open}
      confirmText="Done"
      unsetOverflow
      isPending={saving}
    >
      <div className={styles.agentTitleContent}>
        <h4>Edit Title</h4>
        <TitleInput
          values={titleValue}
          setFieldValue={(key, val) => setTitleValue({ [key]: val })}
        />
      </div>
    </ConfirmationDialog>
  );
};

export default EditTitleModal;
